'use client'
import { montserratBold, montserratLight, montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import { featuresRecon } from '@/helpers/content/id/services/reconciliation-automation/features';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react'
import FeatureAudit from './FeatureAudit';
import FeatureHistori from './FeatureHistori';
import FeatureIntegrasi from './FeatureIntegrasi';
import FeatureReconciliation from './FeatureReconciliation';
import { t } from 'i18next';
// import reconVideo from "/features/freya-recon.mp4"

export default function Feature() {

  const router = useRouter()
  const videoRef = useRef(null);
  const videoRefMobile = useRef(null)
  const [indexChoosed, setindexChoosed] = useState(0)

  useEffect(() => {
    if (router.isReady) {
      const play = document.getElementById("playButton");
      if (play) {
          play.click()
      }
    }
  }, [router]);

  const clickButton = () => {
    const video = videoRef.current;
    const videoMobile = videoRefMobile.current;
    console.log("PLAy")
    console.log(video)
    video.muted = true
    video.play().catch(error => {
      console.error("Error attempting to play the video:", error);
    });
    videoMobile.muted = true
    videoMobile.play().catch(error => {
      console.error("Error attempting to play the video:", error);
    });
  }

  const handleChangeIndex = (index) => {
    setindexChoosed(index)
  }

  return (
    <div className='flex w-full h-full relative px-4 lg:px-8 py-16'>
      <button id='playButton' onClick={clickButton} className='absolute hidden -z-50'>Klik</button>
      <div className='hidden lg:flex lg:container max-w-[1280px] lg:mx-auto w-full h-full'>
        <div className='block'>
          <p className={`${montserratSemibold.className} pb-3 text-base text-blue-primary-500`}>{t('recon_feature_tiny_title')}</p>
          <h1 className={`${montserratBold.className} text-[36px] w-auto lg:w-[20rem] pb-4 text-gray-cool-700`}>{t('recon_feature_title')}</h1>
          <ul className='flex flex-col'>
            {
              featuresRecon.map((val,i) => (
                <li onClick={() => handleChangeIndex(i)} key={i} className='border-t border-gray-cool-200 hover:cursor-pointer py-4'><p className={`${montserratNormal.className} text-[24px] ${indexChoosed == i ? "text-gray-cool-700" : "text-gray-cool-300"}`}>{t(val.title)}</p></li>
              ))
            }
          </ul>
        </div>
        <div className='lg:flex hidden w-full h-full'>
          {
            indexChoosed == 0 && (
              <FeatureReconciliation videoRef={videoRef} />
            )
          }
          {
            indexChoosed == 1 && (
              <FeatureAudit />
            )
          }
          {
            indexChoosed == 2 && (
              <FeatureIntegrasi />
            )
          }
          {
            indexChoosed == 3 && (
              <FeatureHistori />
            )
          }
        </div>
      </div>
      <div className='lg:hidden overflow-x-scroll overflow-y-hidden flex flex-col h-full relative '>
            <div className='h-full lg:hidden'>
                    <div className='space-x-4 overflow-x-scroll overflow-y-hidden w-[105rem] px-4 flex h-full'>
                    {
                        featuresRecon.map((val,index) => (
                            <div className='p-4 flex flex-col w-[400px] h-[750px] rounded-lg border border-gray-cool-300 bg-gray-cool-50'>
                                <div className='block py-4 justify-center items-center'>
                                  <div className='block'>
                                    <p className={`text-blue-primary-500 ${montserratSemibold.className} pb-[6px]`}>{t(val.title)}</p>
                                      <h3 className={`${montserratBold.className} leading-[24px] h-[48px] mb-[12px] text-gray-cool-700 text-[20px]`}>
                                        {
                                          index == 0 && 
                                            (
                                              t('recon_feature_list_detail_title_1')
                                            )
                                        }
                                        {
                                          index == 1 && 
                                            (t("recon_feature_list_detail_title_2"))
                                        }
                                        {
                                          index == 2 && 
                                            (t("recon_feature_list_detail_title_3"))
                                        }
                                        {
                                          index == 3 && 
                                          (t("recon_feature_list_detail_title_4"))
                                        }
                                      </h3>
                                    </div>
                                    {
                                      index == 0 ? (
                                      <div className='border w-[360px] overflow-hidden flex border-gray-cool-200 rounded-lg relative mt-4'>
                                        <video id="videoReconMobile" ref={videoRefMobile} src={"/features/freya-recon.mp4"} autoPlay loop></video>
                                      </div>
                                      ) : (
                                      <div className='border w-[360px] overflow-hidden mt-4 flex border-gray-cool-200 rounded-lg relative'>
                                        {val.image()}
                                      </div>
                                      )
                                    }
                                    {
                                      index == 0 && (
                                        <div className='block w-full'>
                                          <p className={`${montserratNormal.className} text-gray-cool-500 text-base text-wrap py-6`}>{t('recon_feature_list_detail_description_1_part_1')}</p>
                                          <p className={`${montserratNormal.className} text-gray-cool-500 text-base text-wrap`}>{t('recon_feature_list_detail_description_1_part_2')}</p>
                                        </div>
                                      )
                                    }
                                    {
                                      index == 1 && (
                                        <ul className='block space-y-6 py-6  w-full'>
                                          <li className='flex justify-center space-x-3'>
                                            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                            <p className={`${montserratLight.className} text-base text-gray-cool-500`}><span className={`${montserratMedium.className} pr-1 text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_1')}</span>{t('recon_feature_list_detail_description_2_detail_part_1')}</p>
                                          </li>
                                          <li className='flex justify-center space-x-3'>
                                            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                            <p className={`${montserratLight.className} text-base text-gray-cool-500`}><span className={`${montserratMedium.className} pr-1 text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_2')}</span>{t('recon_feature_list_detail_description_2_detail_part_2')}</p>
                                          </li>
                                          <li className='flex justify-center space-x-3'>
                                            <span className='relative w-10 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                            <p className={`${montserratLight.className} text-base text-gray-cool-500`}><span className={`${montserratMedium.className} pr-1 text-gray-cool-700`}>{t('recon_feature_list_detail_description_2_bold_part_3')}</span>{t('recon_feature_list_detail_description_2_detail_part_3')}</p>
                                          </li>
                                        </ul>
                                      )
                                    }
                                    {
                                      index == 2 && (
                                        <div>
                                          <ul className='flex space-x-[20px] py-6 w-full'>
                                            <li className='flex justify-center space-x-1'>
                                              <span className='relative w-5 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                              <p className={`${montserratNormal.className} text-base`}>{t('recon_feature_list_detail_description_3_bold_part_1')}</p>
                                            </li>
                                            <li className='flex justify-center space-x-1'>
                                              <span className='relative w-5 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                              <p className={`${montserratNormal.className} text-base`}>{t('recon_feature_list_detail_description_3_bold_part_2')}</p>
                                            </li>
                                            <li className='flex justify-center space-x-1'>
                                              <span className='relative w-5 top-1 text-blue-primary-500'><CheckCircleIcon className='absolute'/></span>
                                              <p className={`${montserratNormal.className} text-base`}>{t('recon_feature_list_detail_description_3_bold_part_3')}</p>
                                            </li>
                                          </ul>
                                          <p className={`${montserratNormal.className} text-gray-cool-500`}>{t('recon_feature_list_detail_description_3_detail_part_1')}</p>
                                          <p className={`${montserratNormal.className} pt-6 text-gray-cool-500`}>{t('recon_feature_list_detail_description_3_detail_part_2')}</p>
                                        </div>
                                      )
                                    }
                                    {
                                      index == 3 && (
                                        <div className={`${montserratLight.className} pt-6 text-gray-cool-500`}>{t('recon_feature_list_detail_description_4_detail')}</div>
                                      )
                                    }
                                </div>
                                {/* <ul className='flex space-y-4 pb-4 justify-between flex-col'>
                                    {
                                        val.list_detail.map((service, i) => (
                                            <li className='w-fit h-fit flex'>
                                                <div className='relative flex pr-[12px]'>
                                                    <div className='flex rounded-full left-0 w-5 h-5 justify-center items-center bg-gray-cool-100'>
                                                        <Image src={checklist} />
                                                    </div>
                                                </div>
                                                <div className={`${montserratNormal.className} text-gray-cool-500 text-sm`}>{service.name}</div>
                                            </li>
                                        ))
                                    }
                                </ul> */}
                               
                            </div>
                        ))
                    }
                    </div>
            </div>
      </div>
    </div>
  )
}
